/**
 * Created by vladislav on 02.10.2020
 */

const EyeBoosterView = cc.Node.extend({
    ctor: function (booster, boardView) {
        this._super();

        this.booster = booster;
        this.grid = boardView.grid;
        this.boardView = boardView;
        this.board = boardView.board;

        this.setAnchorPoint(0.5, 0.5);

        this.soundNode = new cc.Node();
        this.addChild(this.soundNode);

        this.booster.on("giveBonus", this.giveBonus.bind(this), this);

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            EyeBoosterView.ANIMATION_TIME_SCALE = 0.6;
            EyeBoosterView.SINGLE_PASS_TIME = 2.25;
        }
    },
 
    giveBonus: function () {
        const scene = cleverapps.Scenes.GetRunningScene();

        const animation = new cleverapps.Spine(bundles.game.jsons.eye_booster_json);
        scene.addChild(animation);
        animation.setLocalZOrder(110);
        animation.setAlignment(cleverapps.styles.EyeBoosterView.animation);
        animation.setAnimation(0, "show", false);
        animation.setCompleteListener(() => {
            animation.setAnimation(0, "activate", false);
            animation.setCompleteListenerRemove();
            animation.setTimeScale(EyeBoosterView.ANIMATION_TIME_SCALE);

            const elements = [];
            this.grid.placeholders.forEach((wordPlaceholders, wordIndex) => {
                wordPlaceholders.forEach((placeholder, letterIndex) => {
                    if (!this.board.foundWordsSet[this.board.words[wordIndex]]) {
                        const letterSprite = this.boardView.createLetter(this.board.words[wordIndex][letterIndex].toUpperCase());
                        this.grid.addChild(letterSprite);
                        letterSprite.onResize = function () {
                            letterSprite.setAlignment(this.grid.getCell(wordIndex, letterIndex).x, this.grid.getCell(wordIndex, letterIndex).y + cleverapps.styles.BoardView.Letter.paddingBottom);
                        }.bind(this);
                        letterSprite.onResize();
                        elements.push(letterSprite);
                    }
                });
            });

            elements.sort((a, b) => a.x - b.x);

            this.soundNode.runAction(new cc.RepeatForever(new cc.Sequence(
                cleverapps.effects.fireAction("boosters_before.eye.use"),
                new cc.DelayTime(2.4)
            )));

            this.runPass(elements, 0);
        });

        cleverapps.effects.fire("boosters_before.eye.start");
    },

    runPass: function (elements, index) {
        if (index === EyeBoosterView.PASSES_COUNT) {
            this.onAllPassesFinished(elements);
            return;
        }

        const styles = cleverapps.styles.EyeBoosterView;
        const MIN_OPACITY_OFFSET = styles.MIN_OPACITY_OFFSET;
        const MAX_OPACITY_OFFSET = styles.MAX_OPACITY_OFFSET;

        const minX = elements[0].x - MIN_OPACITY_OFFSET;
        const maxX = elements[elements.length - 1].x + MIN_OPACITY_OFFSET;
        const dist = maxX - minX;

        const cb = cleverapps.wait(elements.length, this.runPass.bind(this, elements, index + 1));

        elements.forEach((placeholder) => {
            let x;
            if (index % 2 === 0) {
                x = placeholder.x;
            } else {
                x = maxX - placeholder.x;
            }

            const delay = (x - MIN_OPACITY_OFFSET - minX) / dist * EyeBoosterView.SINGLE_PASS_TIME;
            const duration = (x - MAX_OPACITY_OFFSET - minX) / dist * EyeBoosterView.SINGLE_PASS_TIME - delay;
            placeholder.setOpacity(0);
            placeholder.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.FadeIn(duration),
                new cc.FadeOut(duration),
                new cc.CallFunc(cb)
            ));
        });
    },

    onAllPassesFinished: function (elements) {
        this.soundNode.stopAllActions();

        elements.forEach((element) => {
            element.removeFromParent();
        });

        this.board.showUpLetters(false);
        this.board.showUpCoins(false);
        this.board.showUpStars(false);
        this.board.trigger("afterShowUp", false);
    }
});

EyeBoosterView.ANIMATION_TIME_SCALE = 0.8;
EyeBoosterView.SINGLE_PASS_TIME = 1.8;
EyeBoosterView.PASSES_COUNT = 2;

cleverapps.styles.EyeBoosterView = {
    MIN_OPACITY_OFFSET: 300,
    MAX_OPACITY_OFFSET: 100,

    animation: {
        x: { align: "center" },
        y: { align: "center" }
    }
};